import { types } from '../../types/types'

export const authReducer = (state = {}, action) => {

	switch (action.type) {
		case types.login:
			return {
				address: action.payload.data.address,
				city: action.payload.data.city,
				cityId: action.payload.data.cityId,
				civilState: action.payload.data.civilState,
				codePhone: action.payload.data.codePhone,
				contact: action.payload.data.contact,
				country: action.payload.data.country,
				countryId: action.payload.data.countryId,
				date: action.payload.data.date,
				dni: action.payload.data.dni,
				dniType: action.payload.data.dniType ?? '',
				education: action.payload.data.education,
				email: action.payload.data.email,
				emailContact: action.payload.data.emailContact,
				gender: action.payload.data.gender,
				imgProfile: action.payload.data.imgProfile,
				lastnameFirst: action.payload.data.lastnameFirst,
				lastnameSecond: action.payload.data.lastnameSecond,
				medicalPlan: action.payload.data.medicalPlan,
				nameFirst: action.payload.data.nameFirst,
				nameSecond: action.payload.data.nameSecond,
				nationality: action.payload.data.nationality,
				notificationChatSalutaMobile: action.payload.data.notificationChatSalutaMobile,
				numberContact: action.payload.data.numberContact,
				occupation: action.payload.data.occupation,
				phone: action.payload.data.phone,
				region: action.payload.data.region,
				regionId: action.payload.data.regionId,
				socialName: action.payload.data.socialName,
				typeUser: action.payload.data.typeUser,
				uid: action.payload.uid,
			}

		case types.loginDoctor:
			return {
				address: action.payload.data.address,
				city: action.payload.data.city,
				cityId: action.payload.data.cityId,
				civilState: action.payload.data.civilState,
				codePhone: action.payload.data.codePhone,
				contact: action.payload.data.contact,
				countries: action.payload.data.countries,
				country: action.payload.data.country,
				countryId: action.payload.data.countryId,
				date: action.payload.data.date,
				dni: action.payload.data.dni,
				dniType: action.payload.data.dniType ?? '',
				education: action.payload.data.education,
				email: action.payload.data.email,
				emailContact: action.payload.data.emailContact,
				gender: action.payload.data.gender,
				imgProfile: action.payload.data.imgProfile,
				lastnameFirst: action.payload.data.lastnameFirst,
				lastnameSecond: action.payload.data.lastnameSecond,
				medicalPlan: action.payload.data.medicalPlan,
				nameFirst: action.payload.data.nameFirst,
				nameSecond: action.payload.data.nameSecond,
				nationality: action.payload.data.nationality,
				numberContact: action.payload.data.numberContact,
				occupation: action.payload.data.occupation,
				phone: action.payload.data.phone,
				region: action.payload.data.region,
				regionId: action.payload.data.regionId,
				signature: action.payload.data.signature,
				socialName: action.payload.data.socialName,
				typeUser: action.payload.data.typeUser,
				uid: action.payload.uid,
				dataProf: action.payload.data.dataProf,
				host: action.payload.data.host
			}

		case types.loadDataProf:
			return {
				...action.payload
			}

		case types.logout:
			return {}

		default:
			return state;
	}
}